export default __webpack_public_path__ + "static/media/camera_enabled.75bed904.svg";